import React from 'react'
import { ToastContainer, toast } from 'react-toastify';


const ToastContainerAllie = ({ }) => {
  
	return (
		<ToastContainer
			position="bottom-right"
			autoClose={5000}
			hideProgressBar={false}
			newestOnTop={false}
			closeOnClick
			rtl={false}
			pauseOnFocusLoss
			draggable
			pauseOnHover
			theme="light">
		</ToastContainer>
	);
  };
  
export default ToastContainerAllie;